import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
  computed,
} from '@angular/core'

import { GeneratedContent } from '@cyborg-monorepo/hunter/common'
import { CodeBlockComponent } from '@hyperkit'

import { SessionService } from '@hunt/services'

import { ReportQueryHeaderComponent } from '../../report-query-header/report-query-header.component'
import { ReportTextBlockComponent } from '../report-text-block/report-text-block.component'

@Component({
  standalone: true,
  imports: [
    ReportQueryHeaderComponent,
    ReportTextBlockComponent,
    CodeBlockComponent,
  ],
  selector: 'report-pivot-block',
  templateUrl: './report-pivot-block.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportPivotBlockComponent {
  @Input() pivot!: GeneratedContent
  @Input() parentCategory?: string
  readonly session = inject(SessionService)
  readonly loaded = computed(
    () => !this.session.loading() && this.session.activeHunt() !== null,
  )
}
